import * as yup from 'yup';
import { alphabetRegix, alphaNumericRegix, alphaNumericSpecialCharacterRegix, digitsAndHyphenRegex, numericRegix, phoneRegex } from '../utils/functions';
import { isValidPhoneNumber } from 'libphonenumber-js';
export const contact_info_validation_schema = yup.object().shape({
  contactPersonName: yup.string().required('contact_person_name_is_required').matches(alphabetRegix, 'must_be_alphabetic'),
  jobTitle: yup.string().required('job_title_is_required').matches(alphabetRegix, 'must_be_alphabetic'),
  workPhoneNumber: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'valid-phone',
      'invalid_phone_no',
      function (value) {
        if (!value || value.trim() === '') {
          return true;
        }
        return isValidPhoneNumber(value);
      }
    ),
  mobileNumber: yup
    .string()
    .required('mobile_no_is_required')
    .test(
      'is-valid-phone',
      'invalid_phone_no',
      (value) => {
        if (!value) return false;
        return isValidPhoneNumber(value);
      }
    ),
  workEmail: yup.string().email('invalid_email').required('work_email_is_required'),
  preferredLanguageForCorrespondence: yup.string().required('preferred_language_is_required'),
  contactPreferenceEmail: yup.array().min(1, 'preferred_correspondence_is_required').required('preferred_correspondence_is_required'),
  countryNonKsa: yup.string().when('isKsa', {
    is: true,
    then: (schema) => schema.required('country_is_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  buildingNumberKsa: yup.string().when('isKsa', {
    is: true,
    then: (schema) => schema
      .required('building_number_is_required')
      .matches(digitsAndHyphenRegex, 'invalid_building_no'),
    otherwise: (schema) => schema.notRequired(),
  }),
  streetNameKsa: yup.string().when('isKsa', {
    is: true,
    then: (schema) => schema
      .required('street_name_is_required')
      .matches(alphaNumericRegix, 'must_be_alphanumeric'),
    otherwise: (schema) => schema.notRequired(),
  }),
  districtKsa: yup.string().when('isKsa', {
    is: true,
    then: (schema) => schema
      .required('district_is_required')
      .matches(alphaNumericSpecialCharacterRegix, 'must_be_alphanumeric'),
    otherwise: (schema) => schema.notRequired(),
  }),
  cityKsa: yup.string().when('isKsa', {
    is: true,
    then: (schema) => schema
      .required('city_is_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  postalCodeKsa: yup.string().when('isKsa', {
    is: true,
    then: (schema) => schema
      .required('zip_code_is_required')
      .matches(digitsAndHyphenRegex, 'invalid_zip_code'),
    otherwise: (schema) => schema.notRequired(),
  }),
  additionalNumberKsa: yup.string(),
  unitNoKsa: yup.string().when('isKsa', {
    is: true,
    then: (schema) => schema
      .required('unit_number_is_required').matches(numericRegix, 'unit_no_must_be_numeric'),
    otherwise: (schema) => schema.notRequired(),
  }),
  anyOtherFinancialInfo: yup.string(),
});
